/** The crime map's points as columns, as getCrimeData sends them with compact=true. */
export interface CrimeColumns {
  ids: string[];
  latitudes: number[];
  longitudes: number[];
  values: Record<'date' | 'time' | 'category' | 'description', Array<string | null>>;
  codes: Record<'date' | 'time' | 'category' | 'description', number[]>;
}

export interface CrimeRow {
  'Incident ID': string;
  'Incident Date': string | null;
  'Incident Time': string | null;
  'Incident Category': string | null;
  'Incident Description': string | null;
  Latitude: number;
  Longitude: number;
}

/**
 * Rebuild the row objects the map uses. Columns store each repeated text once,
 * so the response is about a quarter the size and parses faster.
 */
export function expandCrimeColumns(columns: CrimeColumns): CrimeRow[] {
  const { ids, latitudes, longitudes, values, codes } = columns;
  const rows: CrimeRow[] = new Array(ids.length);
  for (let i = 0; i < ids.length; i += 1) {
    rows[i] = {
      'Incident ID': ids[i],
      'Incident Date': values.date[codes.date[i]],
      'Incident Time': values.time[codes.time[i]],
      'Incident Category': values.category[codes.category[i]],
      'Incident Description': values.description[codes.description[i]],
      Latitude: latitudes[i],
      Longitude: longitudes[i],
    };
  }
  return rows;
}
